const extractString = (inputString = "") => {
  const parts = inputString.split("_");

  // Remove numeric prefixes from the start only
  let i = 0;
  while (i < parts.length && /^[0-9]+$/.test(parts[i])) {
    i++;
  }

  // Take the rest after numeric prefix
  let result = parts.slice(i).join(" ");

  // Normalize 'MAINS' -> 'MAIN'
  if (result.includes("MAINS")) result = result.replace("MAINS", "MAIN");

  return result.trim();
};

export default extractString;
